import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { track } from '@/lib/analytics'

export function useTrackPageView() {
  const location = useLocation()
  useEffect(() => {
    track('page_view', location.pathname)
  }, [location.pathname])
}
